export enum EFieldNames {
  UserName = 'userName',
  Email = 'email',
  Password = 'password',
  ConfirmPassword = 'confirmPassword',
  FirstName = 'firstName',
  LastName = 'lastName',
  Address = 'street',
  City = 'city',
  State = 'state',
  Zip = 'zip',
  Policy = 'isAgreedToPrivacyPolicyAndTermsAndconditions',
  Organization = 'organizationName',
  OrganizationType = 'organizationType',
  Phone = 'phoneNumber',
  Note = 'note',
  Country = 'country'
}
